import { ChangeDetectionStrategy, Component, Input, Optional, Self } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormGroupDirective, NgControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { NOOP_VALUE_ACCESSOR } from '../../constants/noop-value-accessor.const';
export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}
@Component({
  selector: 'app-checkbox-widget',
  templateUrl: './checkbox-widget.component.html',
  styleUrls: ['./checkbox-widget.component.scss'],
  viewProviders: [
    {
      // Serves the parent form control
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})

export class CheckboxComponent {


  
  allComplete: boolean = false;


  @Input('color') color: ThemePalette = 'primary';
  @Input('text') text: string = 'Placeholder Text';
  @Input('formControlName') formControlName: string | null;


  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = NOOP_VALUE_ACCESSOR;
    }
  }


}